import { useMemo } from 'react';

function useMuiError(error) {
  return useMemo(() => (error ? { error: true, helperText: error } : { error: false }), [error]);
}

export default useMuiError;
